// extracted by mini-css-extract-plugin
export var burgerContainer = "Header-module--burgerContainer--c7ec8";
export var burgerContainerTablet = "Header-module--burgerContainerTablet--96860";
export var header = "Header-module--header--357cc";
export var headerMain = "Header-module--headerMain--eff39";
export var headerSecondary = "Header-module--headerSecondary--9f8a8";
export var headerWrapper = "Header-module--headerWrapper--212dc";
export var horizontalSpacer = "Header-module--horizontalSpacer--b44ce";
export var iconHeader = "Header-module--iconHeader--2716d";
export var iconSecondary = "Header-module--iconSecondary--14a9a";
export var languageChevronDown = "Header-module--languageChevronDown--82b61";
export var languageOrSearch = "Header-module--languageOrSearch--7dd97";
export var languageOrSearchScroller = "Header-module--languageOrSearchScroller--12df4";
export var languageSwitch = "Header-module--languageSwitch--d59f5";
export var languageSwitchFlag = "Header-module--languageSwitchFlag--f702e";
export var logoOnly = "Header-module--logoOnly--69884";
export var ridestoreLogo = "Header-module--ridestoreLogo--edd35";
export var secondaryTitle = "Header-module--secondaryTitle--e89f5";
export var sustainability = "Header-module--sustainability--40a4b";